export default __webpack_public_path__ + "static/media/01.eeb8ca02.png";